var _excluded = ["children", "keepMounted"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useMemo, useRef } from 'react';
import { createHtmlPortalNode, InPortal, OutPortal } from 'react-reverse-portal';
import { Item, TabPanels } from '@adobe/react-spectrum';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Wrapper for react-spectrum TabPanels that adds support for keeping panels mounted
 * when not visible using the `keepMounted` prop.
 * Panels created with a render function will not be kept mounted.
 */
export function DHCTabPanels(props) {
  var children = props.children,
    _props$keepMounted = props.keepMounted,
    keepMountedProp = _props$keepMounted === void 0 ? false : _props$keepMounted,
    rest = _objectWithoutProperties(props, _excluded);
  var keepMounted = keepMountedProp && typeof children !== 'function';
  var portalNodeMap = useRef(new Map());
  var portalNodes = useMemo(() => {
    var nodes = [];
    var nextNodeMap = new Map(); // Keep track of the portals we use so we can clean up stale portals
    if (!keepMounted) {
      portalNodeMap.current = nextNodeMap;
      return nodes;
    }
    React.Children.forEach(children, child => {
      // Spectrum would ignore these anyway because it uses Item key to determine if the panel mounts
      if (child == null || child.key == null) {
        return;
      }

      // Skip children with function-based content (i.e. ItemRenderer) as it can't be portaled
      if (typeof child.props.children === 'function') {
        throw new Error('DHCTabPanels cannot use keepMounted with an ItemRenderer function as its children');
      }
      var portal = portalNodeMap.current.get(child.key);
      if (portal == null) {
        portal = createHtmlPortalNode({
          attributes: {
            // Should make the placeholder div not affect layout and act as if children are mounted directly to the parent
            style: 'display: contents'
          }
        });
      }
      nextNodeMap.set(child.key, portal);
      nodes.push(/*#__PURE__*/_jsx(InPortal, {
        node: portal,
        children: child.props.children
      }, child.key));
    });
    portalNodeMap.current = nextNodeMap;
    return nodes;
  }, [children, keepMounted]);
  var mappedChildren = useMemo(() => {
    var newChildren = [];
    if (!keepMounted) {
      return newChildren;
    }
    // Need to use forEach instead of map because map always changes the key of the returned elements
    React.Children.forEach(children, child => {
      if (child == null || child.key == null) {
        newChildren.push(child);
        return;
      }
      var portal = portalNodeMap.current.get(child.key);
      if (portal == null) {
        newChildren.push(child);
        return;
      }
      newChildren.push(/*#__PURE__*/_jsx(Item, {
        children: /*#__PURE__*/_jsx(OutPortal, {
          node: portal
        })
      }, child.key));
    });
    return newChildren;
  }, [children, keepMounted]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [keepMounted && portalNodes, /*#__PURE__*/_jsx(TabPanels
    // eslint-disable-next-line react/jsx-props-no-spreading
    , _objectSpread(_objectSpread({}, rest), {}, {
      children: keepMounted ? mappedChildren : children
    }))]
  });
}
//# sourceMappingURL=TabPanels.js.map